<template>
  <div style="height: 100%; overflow-y: auto">
    <a-tabs @change="addTabChange" v-model="activeTab" size="small">
      <a-tab-pane tab="期次选择" key="1">
        <div class="tab_div">
          <a-row>
            <a-col :span="4" class="title">期刊名称：</a-col>
            <a-col :span="6">
              <a-input v-bind:read-only="true" v-model="periodicalName" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="4" class="title">发行年份：</a-col>
            <a-col :span="4">
              <a-input v-bind:read-only="true" v-model="publishInfo.year" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="4" class="title">排刊期次：</a-col>
            <a-col :span="4">
              <a-input
                v-bind:read-only="true"
                :value="`总第${publishInfo.total}期`"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="4" class="title">排刊版本：</a-col>
            <a-col :span="4">
              <a-select
                style="width: 100%"
                placeholder="请选择"
                v-model="publishInfo.sectionInfo"
                @change="onSectionInfoChange"
                :disabled="publishInfo.publishCode != ''"
              >
                <a-select-option
                  v-for="item in sectionInfos"
                  :value="item.dicValue"
                  :key="item.dicValue"
                >
                  {{ item.dicValue }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </div>
      </a-tab-pane>
      <a-tab-pane tab="确定栏目" key="2">
        <a-transfer
          :dataSource="columnData"
          :titles="['可选栏目', '已选栏目']"
          :targetKeys="columnTargetKeys"
          @change="columnChange"
          :render="(item) => item.title"
          :listStyle="{ width: '400px' }"
          style="height: 100%"
        />
      </a-tab-pane>
      <a-tab-pane tab="挑选稿件" key="3">
        <div class="sel-column">
          <ul>
            <li class="title">已选栏目</li>
            <hr class="hr" />
            <li
              @click="liClick"
              class="column_li"
              :class="{ active_li: index == 0 }"
              :id="index"
              v-for="(item, index) in selectedColumn"
              :key="item.key"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div style="float: left; margin-left: 12px; width: calc(100vw - 320px)">
          <a-transfer
            :dataSource="showManuscriptData"
            :show-select-all="false"
            :targetKeys="manuscriptTargetKeys"
            showSearch
            :filter-option="
              (inputValue, item) => item.cnTitle.indexOf(inputValue) !== -1
            "
            :titles="['待选稿件', '已选稿件']"
            @change="manuscriptChange"
            style="height: 100%"
          >
            <template
              slot="children"
              slot-scope="{
                props: { direction, filteredItems, selectedKeys },
                on: { itemSelectAll, itemSelect },
              }"
            >
              <a-table
                :row-selection="
                  getRowSelection({
                    selectedKeys,
                    itemSelectAll,
                    itemSelect,
                  })
                "
                :columns="direction === 'left' ? leftColumns : rightColumns"
                :data-source="filteredItems"
                size="small"
                :custom-row="
                  ({ key }) => ({
                    on: {
                      click: () => {
                        itemSelect(key, !selectedKeys.includes(key));
                      },
                    },
                  })
                "
              />
            </template>
          </a-transfer>
        </div>
      </a-tab-pane>
      <a-tab-pane tab="封面设置" key="4" class="coverSet">
        <a-row :gutter="16" class="set-row">
          <a-col :span="8">
            <div class="set-content">
              <a-divider orientation="left"> 封面设置 </a-divider>
              <a-row>
                <a-col :span="5" class="set-title">
                  <label>要目选择：</label>
                </a-col>
                <a-col :span="18">
                  <a-select
                    placeholder="请选择"
                    style="width: 75%"
                    show-search
                    option-filter-prop="children"
                    :filter-option="coverFilterOption"
                    allowClear
                    v-model="selCoverFirst"
                  >
                    <a-select-option
                      v-for="item in selectedManuscript"
                      :value="item.key"
                      :key="item.key"
                    >
                      {{ item.title }}
                    </a-select-option>
                  </a-select>
                  <a-button
                    style="margin-left: 5px"
                    type="primary"
                    @click="onCoverFirstAdd"
                  >
                    添加
                  </a-button>
                </a-col>
              </a-row>
              <a-row>
                <a-table
                  :pagination="false"
                  :columns="[
                    {
                      title: '稿件题目',
                      dataIndex: 'title',
                      ellipsis: true,
                    },
                    {
                      title: '操作',
                      key: 'action',
                      width: 95,
                      scopedSlots: { customRender: 'action' },
                    },
                  ]"
                  :dataSource="coverFirstShowList"
                  :rowKey="(record) => record.key"
                  size="small"
                  bordered
                  style="margin-left: -1px"
                >
                  <template slot="action" slot-scope="info, record, index">
                    <a-button
                      type="danger"
                      size="small"
                      icon="delete"
                      shape="circle"
                      title="删除"
                      @click="onCoverFirstDelete(info.key)"
                    />
                    <a-button
                      size="small"
                      icon="arrow-up"
                      shape="circle"
                      title="上移"
                      style="margin: 0 3px"
                      @click="onCoverFirstUp(index)"
                    />
                    <a-button
                      size="small"
                      icon="arrow-down"
                      shape="circle"
                      title="下移"
                      @click="onCoverFirstDown(index)"
                    />
                  </template>
                </a-table>
              </a-row>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="set-content">
              <a-divider orientation="left"> 封二设置 </a-divider>
              <a-row>
                <a-col :span="5" class="set-title">
                  <label>
                    插&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;图：
                  </label>
                </a-col>
                <a-col :span="18">
                  <a-upload
                    name="file"
                    :fileList="coverSecond.fileList"
                    :action="uploadAddress"
                    :headers="headers"
                    @change="coverUploadAdd($event, 'second')"
                    :data="fileData"
                    accept=".jpg, .png"
                  >
                    <a-button type="primary" style="margin-left: 10px">
                      上传图片
                    </a-button>
                  </a-upload>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="5" class="set-title">
                  <label> 文字信息：</label>
                </a-col>
                <a-col :span="18">
                  <a-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    v-model="coverSecond.content"
                  />
                </a-col>
              </a-row>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="set-content">
              <a-divider orientation="left"> 封三设置 </a-divider>
              <a-row>
                <a-col :span="5" class="set-title">
                  <label>
                    插&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;图：
                  </label>
                </a-col>
                <a-col :span="18">
                  <a-upload
                    name="file"
                    :fileList="coverThird.fileList"
                    :action="uploadAddress"
                    :headers="headers"
                    @change="coverUploadAdd($event, 'third')"
                    :data="fileData"
                    accept=".jpg, .png"
                  >
                    <a-button type="primary" style="margin-left: 10px">
                      上传图片
                    </a-button>
                  </a-upload>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="5" class="set-title">
                  <label> 文字信息：</label>
                </a-col>
                <a-col :span="18">
                  <a-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    v-model="coverThird.content"
                  />
                </a-col>
              </a-row>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="16" class="set-row" style="margin-top: 1%">
          <a-col :span="8">
            <div class="set-content">
              <a-divider orientation="left"> 封底设置 </a-divider>
              <a-row>
                <a-col :span="5" class="set-title">
                  <label>
                    插&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;图：
                  </label>
                </a-col>
                <a-col :span="18">
                  <a-upload
                    name="file"
                    :fileList="coverLast.fileList"
                    :action="uploadAddress"
                    :headers="headers"
                    @change="coverUploadAdd($event, 'last')"
                    :data="fileData"
                    accept=".jpg, .png"
                  >
                    <a-button type="primary" style="margin-left: 10px">
                      上传图片
                    </a-button>
                  </a-upload>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="5" class="set-title">
                  <label> 文字信息：</label>
                </a-col>
                <a-col :span="18">
                  <a-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    v-model="coverLast.content"
                  />
                </a-col>
              </a-row>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="set-content">
              <a-divider orientation="left"> 目录页设置 </a-divider>
              <a-descriptions bordered class="mulu-set">
                <a-descriptions-item label="期次" :span="3">
                  <span>
                    {{
                      `${this.publishInfo.year}年 第${this.publishInfo.count}期`
                    }}
                  </span>
                </a-descriptions-item>
                <a-descriptions-item label="总期次" :span="3">
                  <span>{{ `总第${this.publishInfo.total}期` }}</span>
                </a-descriptions-item>
                <a-descriptions-item label="出版日期" :span="3">
                  <div>
                    <a-select
                      placeholder="年"
                      v-model="directoryPage.issueYear"
                      size="small"
                      style="width: 65px"
                    >
                      <a-select-option
                        v-for="col in issueYears"
                        :key="col"
                        :value="col"
                      >
                        {{ col }}
                      </a-select-option>
                    </a-select>
                    年
                    <a-select
                      placeholder="月"
                      v-model="directoryPage.issueMonth"
                      size="small"
                      style="width: 55px"
                      @change="onIssueMonthChnage"
                    >
                      <a-select-option
                        v-for="col in issueMonths"
                        :key="col"
                        :value="col"
                      >
                        {{ col }}
                      </a-select-option>
                    </a-select>
                    月
                    <a-select
                      placeholder="日"
                      v-model="directoryPage.issueDate"
                      size="small"
                      style="width: 55px"
                    >
                      <a-select-option
                        v-for="col in issueDates"
                        :key="col"
                        :value="col"
                      >
                        {{ col }}
                      </a-select-option>
                    </a-select>
                    日
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="本期稿件总数" :span="3">
                  <span>
                    {{ `共${directoryPage.manuscriptNum}篇` }}
                  </span>
                </a-descriptions-item>
              </a-descriptions>
            </div>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane tab="上传清样" key="5">
        <div>
          <label>请点击上传本期的PDF图样文件</label>
        </div>
        <div>
          <a-upload
            name="file"
            :action="uploadAddress"
            :headers="headers"
            @change="uploadFile"
            :remove="fileRemove"
            :data="publishFileData"
            accept=".pdf"
          >
            <a-button> <a-icon type="upload" />选择文件 </a-button>
          </a-upload>
          <!-- <label>{{ detailFile.fileName }}</label> -->
        </div>
      </a-tab-pane>
      <a-tab-pane tab="提交审核" key="6">
        <label>
          排刊组稿提交审核之后，所选的稿件将不允许进行修改和删除，您确定要提交审核？
        </label>
      </a-tab-pane>
    </a-tabs>
    <div class="set_btn_div">
      <a-button id="cancel" name="btn" class="btn" @click="cancel">
        取消
      </a-button>
      <a-button id="submit" name="btn" class="btn" @click="save(2)">
        提交
      </a-button>
      <a-button id="save" name="btn" class="btn" @click="save(1)">
        保存并退出
      </a-button>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import difference from "lodash/difference";
export default {
  props: {
    publishRecord: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      uploadAddress: this.$config.serviceAddress + "/file/upload",
      headers: {
        authorization: "authorization-text",
      },
      fileData: {
        fileType: "manuscripts",
      },
      publishFileData: {
        fileType: "qingYang",
      },
      activeTab: "1",
      publishInfo: { count: "", year: "", total: "", sectionInfo: "" },
      periodicalName: "",
      sectionInfos: [],
      yearList: [],
      planList: [],
      columnData: [], // 所有栏目
      columnTargetKeys: [], // 选中栏目
      manuscriptData: [], // 所有稿件
      showManuscriptData: [], // 可选稿件
      manuscriptTargetKeys: [], // 选中稿件
      selectedColumn: [], // 已选栏目
      selectedManuscript: [], // 已选稿件
      selectedIndex: 0, // 当前栏目
      leftColumns: [
        {
          title: "稿件编号",
          dataIndex: "key",
          width: 120,
        },
        {
          title: "标题",
          dataIndex: "title",
        },
        {
          title: "发表建议",
          dataIndex: "description",
        },
      ],
      rightColumns: [
        {
          title: "稿件编号",
          dataIndex: "key",
          width: 120,
        },
        {
          title: "标题",
          dataIndex: "title",
        },
      ],
      coverFirst: [],
      coverFirstShowList: [],
      selCoverFirst: "",
      coverSecond: {
        image: "",
        content: "",
        fileList: [],
      },
      coverThird: {
        image: "",
        content: "",
        fileList: [],
      },
      coverLast: {
        image: "",
        content: "",
        fileList: [],
      },
      issueYears: [],
      issueMonths: [],
      issueDates: [],
      directoryPage: {
        issueYear: 0,
        issueMonth: null,
        issueDate: null,
        manuscriptNum: 0,
      },
      fileList: [],
    };
  },
  mounted() {
    document.getElementById("cancel").style.display = "block";
    let currYear = new Date().getFullYear();
    this.issueYears.push(currYear - 1);
    this.issueYears.push(currYear);
    this.issueYears.push(currYear + 1);
    for (let m = 1; m <= 12; m++) {
      this.issueMonths.push(m);
    }
    this.periodicalName = this.publishRecord.periodicalName;
    this.publishInfo.periodicalCode = this.publishRecord.periodicalCode;
    this.publishInfo.publishCode = this.publishRecord.publishCode;
    this.publishInfo.year = this.publishRecord.year;
    this.publishInfo.total = this.publishRecord.total;
    this.publishInfo.count = this.publishRecord.count;
    this.publishInfo.sectionInfo = this.publishRecord.sectionInfo;
    this.directoryPage.issueYear = this.publishRecord.year;
    this.axios
      .get("/dataDic/queryChild", { params: { parentCode: "section_info" } })
      .then((res) => {
        if (res.data) {
          this.sectionInfos = res.data;
          if (!this.publishRecord.sectionInfo) {
            this.publishInfo.sectionInfo = this.sectionInfos[0].dicValue;
          }
          this.listColumns();
          this.listManuscripts();
        } else {
          this.utils.messageInfo(this, "error", "查询刊物版本失败！");
        }
      });
  },
  methods: {
    addTabChange(key) {
      document.getElementById("save").style.display = "none";
      document.getElementById("submit").style.display = "none";
      if (key == "3") {
        if (this.columnTargetKeys.length == 0) {
          this.utils.messageInfo(this, "error", "请先选择栏目！");
          this.activeTab = "2";
          return;
        }
      } else if (key == "4") {
        if (this.manuscriptTargetKeys.length == 0) {
          this.utils.messageInfo(this, "error", "请先选择稿件！");
          this.activeTab = "3";
          return;
        }
      } else if (key == "5") {
        if (this.coverFirst.length == 0) {
          this.utils.messageInfo(this, "error", "请先选择封面！");
          this.activeTab = "4";
          return;
        } else if (
          this.coverSecond.image == "" ||
          this.coverSecond.content == ""
        ) {
          this.utils.messageInfo(this, "error", "请先选择封二！");
          this.activeTab = "4";
          return;
        } else if (
          this.coverThird.image == "" ||
          this.coverThird.content == ""
        ) {
          this.utils.messageInfo(this, "error", "请先选择封三！");
          this.activeTab = "4";
          return;
        } else if (this.coverLast.image == "" || this.coverLast.content == "") {
          this.utils.messageInfo(this, "error", "请先选择封底！");
          this.activeTab = "4";
          return;
        } else if (
          this.directoryPage.issueMonth == null ||
          this.directoryPage.issueDate == null
        ) {
          this.utils.messageInfo(this, "error", "请先选择目录页出版日期！");
          this.activeTab = "4";
          return;
        }
        document.getElementById("save").style.display = "block";
      } else if (key == "6") {
        document.getElementById("save").style.display = "block";
        document.getElementById("submit").style.display = "block";
      }
    },
    listColumns() {
      this.columnData = [];
      this.axios
        .get("/columnInfo/listColumns", {
          params: {
            sectionInfo: this.publishInfo.sectionInfo,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          var columnList = res.data;
          for (var i = 0; i < columnList.length; i++) {
            this.columnData.push({
              key: columnList[i].columnCode,
              title: columnList[i].columnName,
              description: columnList[i].columnName,
            });
          }
        });
    },
    listManuscripts() {
      this.manuscriptData = [];
      this.axios
        .get("/manuscripts/listManuscripts", {
          params: {
            status: 2,
            auditStatus: 11,
            sectionInfo: this.publishInfo.sectionInfo,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          var manuscriptList = res.data.data;
          for (var i = 0; i < manuscriptList.length; i++) {
            let obj = {
              key: manuscriptList[i].code,
              title: manuscriptList[i].cnTitle,
              description: manuscriptList[i].columnInfo,
              selColIndex: -1,
            };
            this.manuscriptData.push(obj);
            this.showManuscriptData.push({ ...obj });
          }
          if (this.publishInfo.publishCode) {
            this.queryColumn(this.publishInfo.publishCode);
          }
        });
    },
    queryColumn(publishCode) {
      this.axios
        .get("/columnArticle/queryColumnArticle", {
          params: {
            publishCode: publishCode,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            var columnList = res.data.data.columnArticleList;
            for (var i = 0; i < columnList.length; i++) {
              this.columnTargetKeys.push(columnList[i].columnCode);
              this.selectedColumn.push({
                key: columnList[i].columnCode,
                title: columnList[i].columnName,
                description: columnList[i].columnName,
                manuscrips: [],
              });
            }
            var manuscriptList = res.data.data.columnManuscriptList;
            for (let i = 0; i < manuscriptList.length; i++) {
              for (let j = 0; j < this.selectedColumn.length; j++) {
                if (
                  this.selectedColumn[j].key == manuscriptList[i].columnCode
                ) {
                  this.selectedColumn[j].manuscrips.push(
                    manuscriptList[i].code
                  );
                  break;
                }
              }
              let findCol = this.columnData.find(
                (col) => col.key == manuscriptList[i].columnCode
              );
              let colIndex = findCol ? this.columnData.indexOf(findCol) : -1;
              let obj = {
                key: manuscriptList[i].code,
                title: manuscriptList[i].cnTitle,
                description: manuscriptList[i].columnInfo,
                selColIndex: colIndex,
              };
              this.selectedManuscript.push(obj);
              if (this.selectedIndex == colIndex) {
                this.manuscriptTargetKeys.push(manuscriptList[i].code);
                this.showManuscriptData.push({ ...obj });
              }
              this.manuscriptData.push({ ...obj });
            }
            this.queryPublishCover(this.publishInfo.publishCode);
          }
        });
    },
    queryPublishCover() {
      this.axios
        .get("/publishInfo/queryPublishCover", {
          params: {
            publishCode: this.publishInfo.publishCode,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data) {
            this.coverSecond = res.data.coverSecond;
            this.coverThird = res.data.coverThird;
            this.coverLast = res.data.coverLast;
            this.directoryPage = res.data.directoryPage;
            this.coverFirst = res.data.coverFirst;
            this.manuscriptData.forEach((item) => {
              if (this.coverFirst.indexOf(item.key) != -1) {
                this.coverFirstShowList.push(item);
              }
            });
          }
        });
    },
    onSectionInfoChange(val) {
      this.publishInfo.sectionInfo = val;
      this.listManuscripts();
      this.listColumns();
    },
    columnChange(targetKeys, direction, moveKeys) {
      this.columnTargetKeys = targetKeys;
      let changeColumn = this.columnData.filter(
        (col) => moveKeys.indexOf(col.key) != -1
      );
      if (direction == "right") {
        // 添加
        for (let i = 0; i < changeColumn.length; i++) {
          this.selectedColumn.push({ ...changeColumn[i], manuscrips: [] });
        }
      } else if (direction == "left") {
        // 移除
        for (let i = 0; i < this.selectedColumn.length; i++) {
          if (moveKeys.indexOf(this.selectedColumn[i].key) != -1) {
            this.selectedColumn.splice(i, 1);
          }
        }
      }
    },
    liClick(e) {
      var liList = document.getElementsByClassName("column_li");
      for (var k = 0; k < liList.length; k++) {
        liList[k].className = "column_li";
      }
      e.target.className += " active_li";
      this.selectedIndex = e.target.id;
      this.manuscriptTargetKeys = [];
      this.selectedColumn[this.selectedIndex].manuscrips.forEach((item) => {
        this.manuscriptTargetKeys.push(item);
      });
      this.showManuscriptData = [];
      for (let i = 0; i < this.manuscriptData.length; i++) {
        if (
          this.manuscriptData[i].selColIndex == -1 ||
          this.manuscriptData[i].selColIndex == this.selectedIndex
        ) {
          this.showManuscriptData.push({ ...this.manuscriptData[i] });
        }
      }
    },
    manuscriptChange(targetKeys, direction, moveKeys) {
      this.manuscriptTargetKeys = targetKeys;
      if (this.selectedColumn.length == 0) {
        return;
      }
      this.selectedColumn[this.selectedIndex].manuscrips = targetKeys;
      for (let i = 0; i < this.manuscriptData.length; i++) {
        if (this.manuscriptData[i].selColIndex == this.selectedIndex) {
          this.manuscriptData[i].selColIndex = -1;
        }
        if (targetKeys.indexOf(this.manuscriptData[i].key) != -1) {
          this.manuscriptData[i].selColIndex = this.selectedIndex;
        }
      }
      if (direction == "right") {
        this.directoryPage.manuscriptNum += moveKeys.length;
        for (let i = 0; i < this.manuscriptData.length; i++) {
          if (moveKeys.indexOf(this.manuscriptData[i].key) != -1) {
            this.selectedManuscript.push({ ...this.manuscriptData[i] });
          }
        }
      } else {
        this.directoryPage.manuscriptNum -= moveKeys.length;
        for (let i = 0; i < this.selectedManuscript.length; i++) {
          if (moveKeys.indexOf(this.selectedManuscript[i].key) != -1) {
            this.selectedManuscript.splice(i, 1);
          }
        }
      }
    },
    manuscriptFilter(inputValue, option) {
      return option.description.indexOf(inputValue) > -1;
    },
    getRowSelection({ selectedKeys, itemSelectAll, itemSelect }) {
      return {
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows.map(({ key }) => key);
          const diffKeys = selected
            ? difference(treeSelectedKeys, selectedKeys)
            : difference(selectedKeys, treeSelectedKeys);
          itemSelectAll(diffKeys, selected);
        },
        onSelect({ key }, selected) {
          itemSelect(key, selected);
        },
        selectedRowKeys: selectedKeys,
      };
    },
    coverFilterOption(input, option) {
      return option.componentOptions.children[0].text.indexOf(input) >= 0;
    },
    onCoverFirstAdd() {
      if (this.coverFirst.length >= 4) {
        this.utils.messageInfo(this, "error", "最多选择4个稿件！");
        return;
      }
      if (this.selCoverFirst == "") {
        this.utils.messageInfo(this, "error", "请选择一个稿件！");
        return;
      }
      if (this.coverFirst.indexOf(this.selCoverFirst) != -1) {
        this.utils.messageInfo(this, "error", "不能重复选择！");
        return;
      } else {
        this.coverFirst.push(this.selCoverFirst);
        for (let i = 0; i < this.selectedManuscript.length; i++) {
          const element = this.selectedManuscript[i];
          if (element.key == this.selCoverFirst) {
            this.coverFirstShowList.push({ ...element });
            break;
          }
        }
        this.selCoverFirst = "";
      }
    },
    onCoverFirstDelete(key) {
      this.coverFirst.splice(this.coverFirst.indexOf(key), 1);
      for (let i = 0; i < this.coverFirstShowList.length; i++) {
        if (this.coverFirstShowList[i].key == key) {
          this.coverFirstShowList.splice(i, 1);
          break;
        }
      }
    },
    onCoverFirstUp(index) {
      if (index > 0) {
        let temp = { ...this.coverFirst[index] };
        this.coverFirst.splice(index, 1, { ...this.coverFirst[index - 1] });
        this.coverFirst.splice(index - 1, 1, { ...temp });
        let temp2 = { ...this.coverFirstShowList[index] };
        this.coverFirstShowList.splice(index, 1, {
          ...this.coverFirstShowList[index - 1],
        });
        this.coverFirstShowList.splice(index - 1, 1, { ...temp2 });
      }
    },
    onCoverFirstDown(index) {
      if (index < this.coverFirstShowList.length - 1) {
        let temp = { ...this.coverFirst[index] };
        this.coverFirst.splice(index, 1, { ...this.coverFirst[index + 1] });
        this.coverFirst.splice(index + 1, 1, { ...temp });
        let temp2 = { ...this.coverFirstShowList[index] };
        this.coverFirstShowList.splice(index, 1, {
          ...this.coverFirstShowList[index + 1],
        });
        this.coverFirstShowList.splice(index + 1, 1, { ...temp2 });
      }
    },
    coverUploadAdd(info, type) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      fileList = fileList.map((item) => {
        let file = {
          uid: item.uid,
          name: item.name,
          status: item.status,
          url: "",
        };
        if (item.response) {
          file.url = item.response.data.filePath;
        }
        return file;
      });
      if (type == "second") {
        this.coverSecond.fileList = fileList;
      } else if (type == "third") {
        this.coverThird.fileList = fileList;
      } else if (type == "last") {
        this.coverLast.fileList = fileList;
      }
      let data = info.file.response;
      if (info.file.status === "done") {
        if (type == "second") {
          this.coverSecond.image = data.data.filePath;
        } else if (type == "third") {
          this.coverThird.image = data.data.filePath;
        } else if (type == "last") {
          this.coverLast.image = data.data.filePath;
        }
        this.utils.messageInfo(this, "success", "上传成功");
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      } else if (info.file.status === "removed") {
        if (data.code == "OK") {
          this.axios.post("/file/deleteFile", {
            url: data.data.realFilePath,
          });
          if (type == "second") {
            this.coverSecond.image = "";
          } else if (type == "third") {
            this.coverThird.image = "";
          } else if (type == "last") {
            this.coverLast.image = "";
          }
        }
      }
    },
    onIssueMonthChnage(val) {
      let lastDate = new Date(this.directoryPage.issueYear, val, 0).getDate();
      this.issueDates = [];
      for (let d = 1; d <= lastDate; d++) {
        this.issueDates.push(d);
      }
    },
    uploadFile(info) {
      if (info.file.status !== "uploading") {
        this.fileList = info.fileList;
      }
      if (info.file.status === "done") {
        this.utils.messageInfo(this, "success", "上传成功");
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      }
    },
    fileRemove(file) {
      var data = file.response;
      if (data.code == "OK") {
        this.axios.post("/file/deleteFile", {
          url: data.data.realFilePath,
        });
      }
    },
    save(status) {
      var fileList = [];
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].response.code == "OK") {
          fileList.push(this.fileList[i].response.data);
        }
      }
      let formData = {
        publishInfo: this.publishInfo,
        selectedColumn: this.selectedColumn,
        fileList: JSON.stringify(fileList),
        status: status,
        creater: sessionStorage.getItem("userCode"),
        coverFirst: JSON.stringify(this.coverFirst),
        coverSecond: JSON.stringify(this.coverSecond),
        coverThird: JSON.stringify(this.coverThird),
        coverLast: JSON.stringify(this.coverLast),
        directoryPage: JSON.stringify(this.directoryPage),
      };
      if (!this.publishInfo.publishCode) {
        this.axios
          .post("/publishInfo/savePublishInfo", formData)
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "添加成功");
              this.cancel();
            } else {
              this.utils.messageInfo(this, "error", "添加失败！");
            }
          });
      } else {
        this.axios
          .post("/publishInfo/updatePublishInfo", formData)
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "编辑成功");
              this.cancel();
            } else {
              this.utils.messageInfo(this, "error", "编辑失败！");
            }
          });
      }
    },
    cancel() {
      this.$emit("publishBack");
    },
  },
};
</script>

<style>
.tab_div .ant-row {
  height: 36px;
  line-height: 36px;
}
.set_btn_div {
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.set_btn_div .btn {
  color: #1890ff;
  border-color: #1890ff;
  margin: 0 10px;
  display: none;
}
li {
  list-style-type: none;
}
.sel-column {
  float: left;
  width: 200px;
  height: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.sel-column .title {
  margin-top: 7px;
  margin-bottom: 7px;
}
.sel-column .hr {
  margin-left: -40px;
  margin-bottom: 0px;
}
.column_li {
  margin-left: -40px;
  padding-left: 15px;
  margin-top: 5px;
  cursor: pointer;
}
.active_li {
  background-color: #1890ff;
}
.set-content {
  padding-bottom: 10px;
}
.coverSet {
  min-height: calc(100vh - 260px);
}
.coverSet .set-row {
  min-height: 47%;
}
.coverSet .ant-col {
  height: 100%;
}
.coverSet .set-content {
  height: 100%;
  border: 1px solid #e8e8e8;
  border-top: none;
}
.coverSet .set-content .ant-divider {
  position: relative;
  top: -12px;
}
.coverSet .set-content .set-title {
  text-align: right;
}
.coverSet .set-content label {
  height: 36px;
  line-height: 36px;
}
.set-content .mulu-set table th,
.set-content .mulu-set table td {
  padding: 8px 12px;
}
</style>